import { fromJS } from 'immutable';

// Constants
import { CONSTANTS } from './constants';
import { api, METHOD, REQUEST_URL, formatPattern } from '../../utils';

const onSavingPotentialsListIsLoading = isLoading => ({
    type: CONSTANTS.ON_SAVING_POTENTIALS_LIST_IS_LOADING,
    payload: { isLoading }
});

const onSavingPotentialsList = data => ({
    type: CONSTANTS.ON_SAVING_POTENTIALS_LIST,
    payload: { data }
});

// ========= THUNKS ============

export const fetchSavingPotentials = meterId => (dispatch, getState) => {
    const savingPotentialsState = getState().reports.get('savingPotentials');
    if (savingPotentialsState.get('isLoading')) return;
    dispatch(onSavingPotentialsListIsLoading(true));

    return api(formatPattern(REQUEST_URL.SAVING_POTENTIALS_BY_METER_ID, {meterId}), METHOD.GET)
        .then(res => {
            if (res && res.ok) {
                dispatch(onSavingPotentialsList(fromJS(res.body)));
                dispatch(onSavingPotentialsListIsLoading(false));
            }
        })
        .catch(err => {
            dispatch(onSavingPotentialsListIsLoading(false));
            throw err;
        });
};
